import React from 'react';
import { Divider, Form } from 'semantic-ui-react'

const VerCliDX1 = ({autorizacUA, styles, handleClickRegr, args, handleChange, handleSubmit, handleClickUpd,
                    handleClickDel, handleClickClo, idLista}) => {
  const a101001 = autorizacUA.findIndex( autorizac => autorizac === "101001" );
  const a101005 = autorizacUA.findIndex( autorizac => autorizac === "101005" );
  const a101010 = autorizacUA.findIndex( autorizac => autorizac === "101010" );

  if(args.contrato){
    var contrato = document.getElementById("contrato");
    if(contrato){contrato.value = args.contrato}
  }
  if(args.descrClaseServ){
    var descrClaseServ = document.getElementById("descrClaseServ");
    if(descrClaseServ){descrClaseServ.value = args.descrClaseServ}
  }
  if(args.descripcionServicio){
    var descripcionServicio = document.getElementById("descripcionServicio");
    if(descripcionServicio){descripcionServicio.value = args.descripcionServicio}
  }
  if(args.estadoDetDX){
    var estadoDetDX = document.getElementById("estadoDetDX");
    if(estadoDetDX){estadoDetDX.value = args.estadoDetDX}
  }
// console.log(idLista)
  
  return (
    <div>
            <Form onSubmit={(ev)=>handleSubmit(ev, args)}>

      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
      {((idLista.estadoProcDX==="ABIERTA")&&(a101001!==-1||a101005!==-1||a101010!==-1)) &&
        <div>
          <Divider inverted />

          {a101001!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
              <i className="large trash alternate violet icon"></i>
              Eliminar servicios a DX
            </button>
          }
          {a101005!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
              <i className="large edit violet icon"></i>
              DX servicios
            </button>
          }
          {a101010!==-1 &&
            <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickClo}>
              <i className="large edit violet icon"></i>
              CERRAR DX masiva
            </button>
          }
        </div>
      }
      <Divider inverted />

      <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
        <i className="large search yellow icon"></i>
        Buscar
      </button>

      <div className="ui input fluid">
        <input id='contrato' autoComplete="off" name="contrato" type="text" placeholder="Contrato" autoFocus style={styles.dropdown} onChange={handleChange}/>
      </div>
      <div className="ui input fluid">
        <input id='descrClaseServ' autoComplete="off" name="descrClaseServ" type="text" placeholder="Clase de servicio" style={styles.dropdown} onChange={handleChange}/>
      </div>
      <div className="ui input fluid">
        <input id='descripcionServicio' autoComplete="off" name="descripcionServicio" type="text" placeholder="Servicio" style={styles.dropdown} onChange={handleChange}/>
      </div>
      <div className="ui input fluid">
        <input id='estadoDetDX' autoComplete="off" name="estadoDetDX" type="text" placeholder="Estado" style={styles.dropdown} onChange={handleChange}/>
      </div>
    </Form>

    </div>
  )
};

export default VerCliDX1
